import { render } from "./BoxIconGridComponent.vue?vue&type=template&id=2cacf21c&scoped=true"
import script from "./BoxIconGridComponent.vue?vue&type=script&lang=js"
export * from "./BoxIconGridComponent.vue?vue&type=script&lang=js"

import "./BoxIconGridComponent.vue?vue&type=style&index=0&id=2cacf21c&scoped=true&lang=css"
import "./BoxIconGridComponent.vue?vue&type=style&index=1&id=2cacf21c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cacf21c"]])

export default __exports__